import { isBlank } from 'utils/helpers-ts';
import IProduct from '../../../../models/product';
import FloatInput, { FloatInputDebounced } from '../FloatInput';
import { useProductValidations } from '../validation-context/ProductValidationContext';
import { getProductFieldVisibility } from '../utils/productFieldVisibility';

interface IQtyOfBaseItemFieldsProps {
  readOnly?: boolean;
  state: IProduct;
  setState: React.Dispatch<React.SetStateAction<IProduct>>;
  showApoteaFields?: boolean;
}

const QtyOfBaseItemFields = ({ readOnly, state, setState, showApoteaFields }: IQtyOfBaseItemFieldsProps) => {
  const { requiredFields } = useProductValidations();
  const { fields } = getProductFieldVisibility({ product: state, showApoteaFields });

  let lavQuantityError = '';
  if (
    !isBlank(state.palletQtyOfBaseItem) &&
    !isBlank(state.lavQuantity) &&
    Number(state.lavQuantity) > Number(state.palletQtyOfBaseItem)
  ) {
    lavQuantityError = 'LAV får inte överstiga kfp/pall';
  }

  return (
    <>
      {fields.consumer_size_to_order_size_ratio && (
        <FloatInput
          readOnly={readOnly}
          name="consumer_size_to_order_size_ratio"
          placeholder="Ex. 24"
          state={state}
          setState={setState}
          dense={false}
          withLabel
          disabled={state?.isMagazine}
          labelOptions={{
            required: !!requiredFields.consumer_size_to_order_size_ratio,
            heading: 'B-packstorlek, antal konsumentförpackningar per distributionsförpackning (kfp/dfp)',
            text: 'Ange hur många konsumentförpackningar som packas i en distributionsförpackning. Används vid orderläggning.',
          }}
        />
      )}

      {fields.palletQtyOfStorePack && (
        <FloatInput
          readOnly={readOnly}
          withLabel
          dense={false}
          name="palletQtyOfStorePack"
          placeholder="Ex. 100"
          labelOptions={{
            heading: 'Antal distributionsförpackningar per pall (dfp/pall)',
            text: 'Ange hur många distributionsförpackningar som packas på en pall. Används vid orderläggning.',
          }}
          state={state}
          setState={setState}
        />
      )}

      {fields.transportQtyOfNextLowerItem && (
        <FloatInput
          readOnly={readOnly}
          withLabel
          dense={false}
          name="transportQtyOfNextLowerItem"
          placeholder="Ex. 10"
          labelOptions={{
            heading: 'Antal distributionsförpackningar per transportförpackning (dfp/tfp)',
            text: 'Ange hur många distributionsförpackningar som packas i en transportförpackning. Används vid orderläggning.',
          }}
          state={state}
          setState={setState}
        />
      )}

      {fields.palletQtyOfNextLowerItem && (
        <FloatInput
          readOnly={readOnly}
          withLabel
          dense={false}
          name="palletQtyOfNextLowerItem"
          placeholder="Ex. 10"
          labelOptions={{
            heading: 'Antal transportförpackningar per pall (tfp/pall)',
            text: 'Ange hur många transportförpackningar som packas på en pall. Används vid orderläggning.',
          }}
          state={state}
          setState={setState}
        />
      )}

      {fields.transportQtyOfBaseItem && (
        <FloatInput
          readOnly={readOnly}
          withLabel
          dense={false}
          name="transportQtyOfBaseItem"
          placeholder="Ex. 240"
          labelOptions={{
            required: !!requiredFields.transportQtyOfBaseItem,
            heading: 'Antal konsumentförpackningar per transportförpackning (kfp/tfp)',
            text: 'Ange hur många konsumentförpackningar som packas i en transportförpackning. Används vid orderläggning.',
          }}
          state={state}
          setState={setState}
        />
      )}

      {fields.lavQuantity && (
        <FloatInputDebounced
          readOnly={readOnly}
          withLabel
          dense={false}
          name="lavQuantity"
          placeholder="Ex. 300"
          labelOptions={{
            required: !!requiredFields.lavQuantity,
            heading: 'Antal konsument-förpackningar per LAV (kfp/lav)',
            text: 'Ange hur många konsumentförpackningar som packas per lav (horisontell nivå på pallen). Används för pallbyggnad.',
          }}
          state={state}
          setState={setState}
          forceRed={!!lavQuantityError}
          errorText={lavQuantityError}
        />
      )}

      {fields.palletQtyOfBaseItem && (
        <FloatInput
          readOnly={readOnly}
          withLabel
          dense={false}
          name="palletQtyOfBaseItem"
          placeholder="Ex. 2400"
          labelOptions={{
            required: !!requiredFields.palletQtyOfBaseItem,
            heading: 'Antal konsumentförpackningar per pall (kfp/pall)',
            text: 'Ange hur många konsumentförpackningar som packas på en pall. Används vid orderläggning.',
          }}
          state={state}
          setState={setState}
        />
      )}
    </>
  );
};

export default QtyOfBaseItemFields;
